export default __webpack_public_path__ + "static/newsAndInsightsPattern-e8ec3d7ebc86c379a0cc4a0a736de526.png";